export const getDate = (value: string, useYear = true) => {
	const date = new Date(value);

	const day = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
	const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
	const year = date.getFullYear();

	return useYear ? `${day}.${month}.${year}` : `${day}.${month}`;
};
